import React, { useState } from "react";
import { AnswerResult, Theme, QuestionAggregate, AppText } from "../types";
import QuestionView from "../Question/Question.component";
import { QuizContainer } from "./Quiz.style";
import { ThemeProvider } from "styled-components";
import { theme } from "../theme";

interface Props {
  theme: Theme;
  questionAggregate: QuestionAggregate;
  onAnswerQuestion: (result: AnswerResult) => void;
  startingIndex?: number;
  text?: AppText;
}

const QuizView: React.FC<Props> = (props) => {
  const questionList = props.questionAggregate.questionList;
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(props.startingIndex || 0);

  const onAnswerQuestion = (result: { idQuestion: string; idAnswers: string[] }) => {
    if (currentQuestionIndex < questionList.length - 1) {
      setCurrentQuestionIndex(currentQuestionIndex + 1);
    }
    props.onAnswerQuestion({
      idQuestion: result.idQuestion,
      idAnswers: result.idAnswers,
    });
  };

  return (
    <ThemeProvider theme={{ ...theme, ...props.theme }}>
      <QuizContainer className="quiz-container">
        <QuestionView
          key={questionList[currentQuestionIndex].id}
          question={questionList[currentQuestionIndex]}
          onAnswerQuestion={onAnswerQuestion}
          text={props.text}
        />
      </QuizContainer>
    </ThemeProvider>
  );
};

export default QuizView;
